/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { PulumiConfigurationsFilterConditions } from '../models/PulumiConfigurationsFilterConditions';

export class PulumiConfigurationsRequest {
  'filters'?: PulumiConfigurationsFilterConditions;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "filters",
      "baseName": "filters",
      "type": "PulumiConfigurationsFilterConditions",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return PulumiConfigurationsRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

